import React, { useContext, useEffect, useState } from "react";
import "./menus.css";
import logo from "../../assets/logo.png";
import settingsIcon from "../../assets/settings.png";
import helpIcon from "../../assets/help.png";
import logoutIcon from "../../assets/logout.png";
import Hamburger from "hamburger-react";
import { AuthContext } from "../../context/auth-context";
import Modal from "../../components/Modal/Modal";
import Select from "react-select";
import { currencies, languages } from "../../utils/data";
import { Link } from "react-router-dom";
import { request } from "../../utils/axios-utils";
import { ClipLoader } from "react-spinners";
import visaLogo from "../../assets/cardLogos/visa.jpeg";
import mastercardLogo from "../../assets/cardLogos/mastercard.jpeg";
import amexLogo from "../../assets/cardLogos/amex.png";
import unknownCardLogo from "../../assets/cardLogos/unknown_card_logo.png";
import cardIcon from "../../assets/card.png";
import noResults from "../../assets/no_results.png";
import { toast } from "react-hot-toast";

const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    color: "var(--darkOrange)",
    width: "calc(100% - 4px)",
    padding: "4px", // Adjust padding as needed, react-select has its own padding
    border: "1px solid var(--darkOrange)",
    borderRadius: "12px",
    fontSize: "16px",
    boxShadow: "none", // Remove focus shadow
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "var(--darkOrange)",
  }),
  input: (provided) => ({
    ...provided,
    color: "var(--darkOrange)",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "var(--darkOrange)",
  }),
};
const getCardBrandLogo = (brand) => {
  const brandLogoMap = {
    visa: visaLogo,
    mastercard: mastercardLogo,
    amex: amexLogo,
  };

  return brandLogoMap[brand?.toLowerCase()] || unknownCardLogo;
};

const Menus = () => {
  const { logout } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const [headerName, setHeaderName] = useState("");
  const [menus, setMenus] = useState([]);
  const [firstMenuCreated, setFirstMenuCreated] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [activeModal, setActiveModal] = useState("");
  const [menuData, setMenuData] = useState({
    name: "",
    slug: "",
    currency: { value: "", label: "Currency" },
    language: { value: "", label: "Language" },
    subscriptionPlan: "yearly",
    paymentMethodId: null,
  });
  const [menuStep, setMenuStep] = useState(1);

  const handleNextStep = async () => {
    setError("");

    if (menuData.name === "") {
      setError("Please enter menu name.");
      return;
    } else if (menuData.slug === "") {
      setError("Menu slug can't be empty.");
      return;
    } else if (menuData.currency.value === "") {
      setError("Please select menu currency.");
      return;
    } else if (menuData.language.value === "") {
      setError("Please select menu main language.");
      return;
    }

    try {
      setLoading("createMenu");
      await request({
        url: "/member/check-menu-exists",
        method: "POST",
        data: { slug: menuData.slug },
      });

      setMenuStep(2);
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  const createMenu = async () => {
    setError("");
    if (paymentMethods.length === 0) {
      setError("Please go to settings and add a payment method.");
      return;
    } else if (menuData.paymentMethodId === null) {
      setError("Please select your payment method.");
      return;
    }

    try {
      setLoading("createMenu");
      const response = await request({
        url: "/member/create-menu",
        method: "POST",
        data: { menuData },
      });

      setMenus((prevData) => [...prevData, response.data.newMenu]);

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading("");
      setActiveModal("");
      setMenuData({
        name: "",
        slug: "",
        currency: { value: "", label: "Currency" },
        language: { value: "", label: "Language" },
        subscriptionPlan: "yearly",
        paymentMethodId: null,
      });
      setMenuStep(1);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading("data");

        const response = await request({ url: "/member/get-menus-data" });

        setHeaderName(response.data.userName);
        setPaymentMethods(response.data.paymentMethods);
        setMenus(response.data.menus);
        setFirstMenuCreated(response.data.firstMenuCreated);
      } catch (error) {
      } finally {
        setLoading("");
      }
    };

    getData();
  }, []);

  return (
    <>
      {activeModal === "createMenu" && (
        <Modal
          heading={"Create new menu"}
          paragraph={"Enter information about your menu."}
          closeModal={() => {
            setActiveModal("");
            setMenuStep(1);
            setError("");
            setMenuData({
              name: "",
              slug: "",
              currency: { value: "", label: "Currency" },
              language: { value: "", label: "Language" },
              subscriptionPlan: "yearly",
              paymentMethodId: null,
            });
          }}
          btnText={menuStep === 1 ? "Next" : "Create"}
          isLoading={loading === "createMenu"}
          btnFuntion={menuStep === 1 ? handleNextStep : createMenu}
        >
          {menuStep === 1 && (
            <>
              <input
                value={menuData.name}
                onChange={(e) => {
                  const newName = e.target.value;

                  const newSlug = newName
                    .toLowerCase()
                    .replace(/[\s]+/g, "-")
                    .replace(/[^a-z0-9-]/g, "");

                  setMenuData((prevData) => ({
                    ...prevData,
                    name: newName,
                    slug: newSlug,
                  }));
                }}
                name="name"
                placeholder="Menu name"
                className="classic-input mb-16"
                maxLength={30}
              />
              <input
                value={menuData.slug}
                onChange={(e) => {
                  const sanitizedSlug = e.target.value
                    .toLowerCase()
                    .replace(/[\s]+/g, "-")
                    .replace(/[^a-z0-9-]/g, "");

                  setMenuData((prevData) => ({
                    ...prevData,
                    slug: sanitizedSlug,
                  }));
                }}
                name="slug"
                placeholder="Menu slug"
                className="classic-input mb-16"
                maxLength={30}
              />

              <Select
                value={menuData.currency}
                className="mb-16"
                styles={customSelectStyles}
                options={currencies}
                onChange={(selectedOption) => {
                  setMenuData((prevData) => ({
                    ...prevData,
                    currency: selectedOption,
                  }));
                }}
                placeholder={"Currency"}
              />

              <Select
                value={menuData.language}
                styles={customSelectStyles}
                options={languages}
                onChange={(selectedOption) => {
                  setMenuData((prevData) => ({
                    ...prevData,
                    language: selectedOption,
                  }));
                }}
                placeholder={"Main Language"}
              />
            </>
          )}

          {menuStep === 2 && (
            <>
              {firstMenuCreated !== true && (
                <div className="menus-modal-free-trial-div">
                  Since this is your first menu, you won't be charged for the
                  first 7 days. You can delete the menu anytime.
                </div>
              )}
              <h3 className="modal-subheading">Subscription Plan</h3>

              <div className="menus-modal-subscriptions-div mb-16">
                <div
                  onClick={() => {
                    setMenuData((prevData) => ({
                      ...prevData,
                      subscriptionPlan: "yearly",
                    }));
                  }}
                  className={`menus-modal-subscription-bar ${
                    menuData.subscriptionPlan === "yearly" &&
                    "menus-modal-subscription-bar-selected"
                  } `}
                >
                  <div>
                    <h4 className="menus-modal-subscription-h">Yearly Plan</h4>
                    <p className="menus-modal-subscription-p">120$/year</p>
                  </div>
                </div>

                <div
                  onClick={() => {
                    setMenuData((prevData) => ({
                      ...prevData,
                      subscriptionPlan: "monthly",
                    }));
                  }}
                  className={`menus-modal-subscription-bar ${
                    menuData.subscriptionPlan === "monthly" &&
                    "menus-modal-subscription-bar-selected"
                  } `}
                >
                  <div>
                    <h4 className="menus-modal-subscription-h">Monthly Plan</h4>
                    <p className="menus-modal-subscription-p">12$/month</p>
                  </div>
                </div>
              </div>

              <h3 className="modal-subheading">Payment Method</h3>
              {paymentMethods?.length > 0 ? (
                <>
                  {paymentMethods?.map((paymentMethod) => {
                    return (
                      <div
                        onClick={() => {
                          setMenuData((prevData) => ({
                            ...prevData,
                            paymentMethodId: paymentMethod.id,
                          }));
                        }}
                        className={`settings-payment-method-bar cursor-pointer mb-8 ${
                          menuData.paymentMethodId === paymentMethod.id &&
                          "settings-payment-method-bar-selected"
                        }`}
                        key={paymentMethod.id}
                      >
                        <div className="settings-payment-method-helper">
                          <img
                            className="settings-payment-method-img"
                            src={getCardBrandLogo(paymentMethod.brand)}
                          />
                          <div>
                            <p className="settings-payment-method-brand-p">
                              {paymentMethod?.brand?.toUpperCase()}
                            </p>
                            <p className="settings-payment-method-number-p">
                              Ending in {paymentMethod?.last4}
                            </p>
                          </div>
                        </div>

                        <div className="select-circle-div">
                          <div
                            className={`select-circle ${
                              menuData.paymentMethodId === paymentMethod.id &&
                              "select-circle-selected"
                            }`}
                          />
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div className="menus-modal-no-payment-div">
                  <img src={cardIcon} className="menus-modal-no-payment-img" />
                  <p className="menus-modal-no-payment-p">
                    No payment methods.
                  </p>
                  <Link
                    className="menus-modal-no-payment-link"
                    to={"/settings"}
                  >
                    Go to settings
                  </Link>
                </div>
              )}
            </>
          )}

          {error && <p className="login-form-error-p">{error}</p>}
        </Modal>
      )}

      <div className="menus-page-container">
        <div className="header-container">
          <div className="header-container-bar-div">
            <Link to={"/"}>
              <img src={logo} className="header-logo-img" />
            </Link>

            <div className="header-text-div">
              <div className="header-help-div">Help</div>
              <Link to={"/settings"} className="header-settings-div">
                <img className="header-settings-img" src={settingsIcon} />
              </Link>
              <div className="header-name-div">
                {loading === "data" ? (
                  <ClipLoader size={15} color="#fff" />
                ) : (
                  <>
                    {headerName}
                    <div onClick={logout} className="logout-div">
                      <p>Log out</p>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="header-hamburger-icon">
              <Hamburger
                toggled={isOpen}
                toggle={() => {
                  setIsOpen((prevState) => !prevState);
                }}
                duration={0.5}
                color="#ed6e12"
              />
            </div>
          </div>

          <div
            className={`header-mobile-container ${
              isOpen === true ? "header-mobile-container-opened" : ""
            }`}
          >
            <div className="header-mobile-link-bar">
              <img src={helpIcon} className="header-mobile-link-img" />
              <p className="header-mobile-link-p">Help</p>
            </div>
            <Link
              to={"/settings"}
              className="header-mobile-link-bar text-decoration-none"
            >
              <img src={settingsIcon} className="header-mobile-link-img" />
              <p className="header-mobile-link-p">Settings</p>
            </Link>
            <div onClick={logout} className="header-mobile-link-bar">
              <img src={logoutIcon} className="header-mobile-link-img" />
              <p className="header-mobile-link-p">Logout</p>
            </div>
          </div>
        </div>

        <div className="menus-page-content-div mt-70">
          <div className="menus-page-div">
            <div className="menus-page-heading-div">
              <h1 className="menus-page-heading">All Menus</h1>
              {/* <div
                onClick={() => {
                  setActiveModal("createMenu");
                }}
                className="menus-page-add"
              >
                Create menu
              </div> */}
            </div>

            <div className="menus-container-helper-div">
              {loading === "data" ? (
                <ClipLoader size={40} color={"#ed6e12"} />
              ) : (
                <div className="menus-container">
                  {menus?.length > 0 ? (
                    <>
                      {menus?.map((menu) => {
                        console.log(
                          menu.status === "active" || menu.status === "trialing"
                        );
                        return (
                          <div key={menu?.slug} className="menu-card-div">
                            <div className="menu-card-text-div">
                              <h2 className="menu-card-h">{menu?.name}</h2>
                              <p className="menu-card-p">{menu?.slug}</p>
                              <p
                                className={`menu-card-status-p ${
                                  menu.status === "active" ||
                                  menu.status === "trialing"
                                    ? "color-green"
                                    : "color-red"
                                }`}
                              >
                                {menu.status}
                              </p>
                              <Link
                                target={"_blank"}
                                to={`https://digitalmenus.co/menus/${menu?.slug}`}
                                className="menu-card-open-p text-decoration-none"
                              >
                                View
                              </Link>
                            </div>
                            <Link
                              to={`/${menu?.slug}/menu-editor`}
                              className="menu-card-btn text-decoration-none"
                            >
                              Enter
                            </Link>
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div className="menus-empty-state-div">
                      <img className="menus-empty-state-img" src={noResults} />
                      <p className="menus-empty-state-p">No menus found.</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Menus;
